import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Slider } from '@material-ui/core'

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext from "../../../contexts/UserContext"


import { TopBar, BottomBar, CenterContainer } from "./FormatsHelpers"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"
import QuestionnaireV2Helper from "../../ui/Admin/Formations/FormatHelpers/QuestionnaireV2Helper"

const FormatQuestionnaireV2 = ({ actFormation, actIndex, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const { manageFormatResponse, manageSlide } = useContext(UserContext)

  const [isAlreadyAnswer, setIsAlreadyAnswer] = useState(false)
  const [userChoice, setUserChoise] = useState(null)
  useEffect(() => {
    if (format?.isDone) {
      setIsAlreadyAnswer(true)
      if (format?.userChoice?.length > 0) {
        setUserChoise( parseInt(format?.userChoice[0]) )
      } else {
        setUserChoise(null)
      }
    } else {
      setIsAlreadyAnswer(false)
      setUserChoise(null)
    }
  }, [format])

  const marks = []
  for(var i=0; i < format?.responses?.length; i++){
    marks.push({value: i+1, label: format?.responses[i]?.label})
  }


  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      height:onlyContent?"100%":"100vh",
      overflow:"hidden",
      gap:"10px"
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <QuestionnaireV2Helper
            format={format}
          />
        </EditorPopover>
      }
      { /* END EDITOR ADMIN */}

      <TopBar
        actFormation={actFormation}
        actIndex={actIndex}
        setViewPlanCours={setViewPlanCours}
        viewPlanCours={viewPlanCours}
        onlyContent={onlyContent}
      />
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
      >
        <EditableField
          field={format?.questions}
          type="questions"
          isEditor={isEditor}
          sx={{
            color:"text.black",
            fontSize:["26px", "40px", "40px", "46px"],
            textAlign:"center",
          }}
        />
        <Slider
          disabled={isAlreadyAnswer}
          value={userChoice + 1}
          onChange={(event, newValue) => {
            setUserChoise(newValue - 1)
          }}
          sx={{
            borderRadius:"0px !important",
            marginTop:["20px", "30px", "30px", "40px"],
            marginBottom:["40px", "70px",],
            maxWidth:"800px",
            height:["4px", "8px"],
            "& .MuiSlider-thumb" : {
              borderRadius:"0px",
              width:["25px", "36px"],
              height:["25px", "36px"],
              border:["2px solid white","4px solid white"],
              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
            },
            "& .MuiSlider-thumb.Mui-active" : {
              boxShadow: "0px 0px 0px 8px rgba(0, 0, 0, 0.16)",
            },
            "& .MuiSlider-thumb:hover" : {
              boxShadow: "0px 0px 0px 8px rgba(0, 0, 0, 0.16)",
            },
            "& .MuiSlider-rail" : {
              backgroundColor:"#D9D9D9",
            },
            "& .MuiSlider-mark" : {
              display:"none"
            },
            "& .MuiSlider-markLabel" : {
              color:"text.black",
              fontSize:["15px", "22px"],
              userSelect:"none",
              top:["33px", "40px", "42px", "45px"],
              overflow:"hidden",
              maxWidth:(120/format?.responses?.length)+"%",
              textOverflow:"ellipsis",
            }
          }}
          aria-labelledby="discrete-slider-restrict"
          step={null}
          valueLabelDisplay="off"
          marks={marks}
          max={format?.responses?.length}
          min={1}
        />
      </CenterContainer>
      <BottomBar
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={isEditor ? false : onlyContent}
        isEditor={isEditor}
        buttons={
          <EditableButton
            isEditor={isEditor}
            disabled={userChoice == null}
            type="button"
            field={format?.button?.text}
            sx={{}}
            onClick={() => {
              manageFormatResponse(format, [{ key: 'isDone', value: true }, { key: 'userChoice', value: [userChoice] }])
              manageSlide(1)
            }}
          />
        }
      />
    </Box>
  )
}


export default FormatQuestionnaireV2
